
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.planForm, arguments)" @resolve="submitHandle">
		<c-form ref="planForm" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="生产计划编号">
					<c-input name="order_code" placeholder="请输入，不填将自动生成"></c-input>
				</c-form-item>
				<c-form-item label="计划时间" required>
					<c-datetime start-name="plan_start_date" end-name="plan_end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
					<template #handle>
						<c-link icon v-if="auth('m_schedule_calendar')" icon="tf-calendar" @click="windowTo({name: 'm_schedule_calendar'})">排产日历</c-link>
					</template>
				</c-form-item>
				<!--自定义字段数据-->
				<custom-form ref="customForm" work-type="2"></custom-form>
			</c-form>

			<c-title>产品明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="productTable" view-id="10014" work-type="48">
					<template #operate>
						<c-button color="main" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_sources:[1, 3]}}}, productSelectorHandle)">添加产品</c-button>
					</template>

					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					
					<!--产品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					
					<!--计划数量-->
					<template #plan_count="{data}">
						<c-input type="number" name="plan_count" decimal="2" :range="[0.01,99999999]" v-model="data.plan_count" :clear="false" :append-text="data.unit"></c-input>
					</template>
					
					<c-table-column
                        type="button"
                        label="操作"
                    >
                        <template #default="{data,remove}">
							<c-table-button v-if="auth('b_plan_create') || auth('b_plan_edit')" icon="tf-trash" color="red" @click="removeProductRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'planEdit',

		data() {
			return {
				order_id:0,
				editState: false,
				h5_web:'',
				deleteProductList: [],
				is_copy:false           //是否是复制页面
			}
		},

		methods: {
			open(data = {}) {
				this.is_copy = data.is_copy||false;
				this.editState = !this.is_copy && !!data.id;
				
				//初始化自定义字段控件
				this.$refs.customForm.init();
				//初始化产品列表控件
				this.$refs.productTable.init();
				
				this.deleteProductList = [];
				//清空表单数据
				this.$refs.planForm.clear();
				
				if (data.id) {
					this.order_id = data.id;
					this.getDetail();
				}else {
					this.order_id = 0;
				}
				this.$refs.dialog.open({
					title: data.id ? (this.is_copy ? '复制生产计划' : '编辑生产计划') : '创建生产计划'
				});
			},
			
			/*******搜索计划单详情*******************/
			getDetail() {
				this.request({
					url:'/plan/detail',
					data: {
						id: this.order_id
					},
					loading: true,
					success: data => {
						
						if (this.is_copy){
							this.order_id = 0;
							data.detailInfo.order_code = '';
						}
						
						this.h5_web = data.detailInfo.h5_web;
						//计划单基本信息
						this.$refs.planForm.set(data.detailInfo);

						//加载产品列表
						this.$refs.productTable.$refs.list.setData(data.productList);
					}
				});
			},

			/******选择产品响应方法*********/
			async productSelectorHandle(data) {
				this.$refs.productTable.$refs.list.push(
					await this.$refs.productTable.setDefaultData(data.map(item => {
						return Object.assign({}, item, {
							product_id: item.id,
							id: null,
							plan_count: 1,
							create_date: null,
							create_user_realname: null
						});
					}), {
						work_type_id: 48,
						source_list: data.map(item => {
							return [{
								ref_work_type_id: 7,
								ref_id: item.product_id
							}]
						})
					})
				);
			},
			
			/******删除产品行数据********/
			removeProductRow(data, remove) {
				if (data.id && data.id > 0){
					this.deleteProductList.push(data.id);
				}
				remove();
			},

			/*******提交编辑数据********************/
			submitHandle(stop, next) {
				stop();
				
				//产品列表
				var product_list = this.$refs.productTable.$refs.list.getData();
				
				this.$refs.planForm.submit({
					url: this.order_id==0?'/plan/add':'/plan/edit',
					rule: {
						plan_start_date: '请选择计划开始时间',
						plan_end_date: '请选择计划结束时间',
						product_list: data => { 
							var flag = true;
							if(product_list.length == 0){
								let msg = "请至少有一个产品信息";
								return msg;
							} 
							product_list.forEach(item => {
								if(!item.plan_count){
									flag = false;
								}
							});

							if (!flag) {
								let msg = "请完善产品明细";
								return msg;
							}
							//自定义字段校验
							return this.$refs.productTable.validate();
						},
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						data.id = this.order_id||0;
						data.customer_id = data.customer_id||0;
						//产品列表
						data.product_list = product_list.map(item => {
							return {
								id: item.id,
								product_id: item.product_id,
								plan_count: item.plan_count,
								custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
							}
						});
						//被删除的任务ID列表
						data.delete_product_list = this.deleteProductList.map(item => {
							return {id:item}
						});
						//表单自定义字段
						data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						return data;
					},
					success: () => {
						next();
						this.$message({
							type: 'success',
							message:this.editState ? '编辑生产计划成功' : '创建生产计划成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>